import {useAuthsState} from "../auths/authsContext";
import {useEffect, useState} from "react";
import {clientLog} from "../clientLog";

/**
 * Hook to get a list of objects, which maps museum IDs to collection IDs for museums
 * where the museum has access to the M24 application.
 * @returns {*[]}
 */
export const useMuseumsWithM24Access = () => {
    const {userData: user, museumCollections} = useAuthsState();
    const [museumsWithM24Access, setMuseumsWithM24Access] = useState([]);

    const getMuseumsWithM24Access = () => museumsWithM24Access;

    const getM24AppId = () => {
        if (!window._env_ || !window._env_.REACT_APP_ID) {
            clientLog('warning', 'Please define REACT_APP_M24_APP_ID in your environment variables to enable M24 access checks.', 'usemuseumswithm24access');
            return null;
        } else {
            return window._env_.REACT_APP_M24_APP_ID;
        }
    };

    /**
     * Hook used to determine whether the user has access to the M24 application.
     */
    useEffect(() => {
        if (!user || !user.appAccess || !user.appAccess?.museums) {
            return false;
        }

        const {museums: userMuseums} = user.appAccess;
        if (typeof userMuseums === "undefined") {
            return false;
        }

        const appM24AppId = getM24AppId(); // Application ID for M24 application
        if (!appM24AppId) {
            setMuseumsWithM24Access([]);
        } else {
            // 1. Filter the list of museums to only contain collections valid for the user.
            // 2. Filter the museums to only those that have access to the M24 application.
            // 3. Map the resulting museums to an object containing museumId and collectionId.
            const museumsWithAccess = userMuseums
                .filter(um => museumCollections.find(mc => mc.museumId === um.id))
                .filter(m => {
                    return m.applications.find(a => a.id === appM24AppId) !== undefined;
                })
                .map(mm => ({
                    'museumId': mm.id,
                    'collectionId': museumCollections.find(mc => mc.museumId === mm.id).collectionId
                }));
            setMuseumsWithM24Access(museumsWithAccess);
        }
    }, [user, museumCollections]);

    return {
        getMuseumsWithM24Access
    };
};